const abs = (real: number, imag: number): number => Math.hypot(real, imag);

export default abs;
